/* hb-flags.js - marks card products that appear in Commander Spellbook combos
   or are Scryfall "is:gamechanger" cards. Data: assets/hb-card-flags.json */
(function(){
  var SRC = window.HB_FLAGS_URL;
  if(!SRC) return;
  var data = null, pending = null;

  function norm(s){
    s = s || '';
    try{
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    }catch(e){}
    return s.replace(/[\u2018\u2019\u02bc]/g, "'")
            .replace(/[\u2013\u2014]/g, '-')
            .toLowerCase()
            .replace(/\u00e6/g,'ae').replace(/\u0153/g,'oe')
            .replace(/\s+/g,' ').trim();
  }
  function front(s){ return String(s||'').split(' // ')[0]; }

  function load(){
    if(data) return Promise.resolve(data);
    if(pending) return pending;
    pending = fetch(SRC).then(function(r){ return r.json(); })
      .then(function(j){ data = (j && j.flags) || {}; return data; })
      .catch(function(){ data = {}; return data; });
    return pending;
  }

  function chip(kind, label, title){
    var s = document.createElement('span');
    s.className = 'hbc-flag hbc-flag--' + kind;
    s.setAttribute('title', title);
    s.textContent = label;
    return s;
  }

  function mark(){
    var nodes = document.querySelectorAll('.hbc-badges[data-hb-card]:not([data-hb-flagged])');
    if(!nodes.length) return;
    load().then(function(f){
      [].forEach.call(nodes, function(el){
        if(el.hasAttribute('data-hb-flagged')) return;
        el.setAttribute('data-hb-flagged','1');
        var v = f[norm(front(el.getAttribute('data-hb-card')))];
        if(!v) return;
        var n = v[0] || 0, gc = v[1] === 1;
        if(gc){
          el.appendChild(chip('gc', 'Game Changer',
            'On the Commander Game Changers list - high-impact card that raises a deck bracket'));
        }
        if(n > 0){
          el.appendChild(chip('combo', n === 1 ? '1 combo' : n + ' combos',
            'Appears in ' + n + ' known Commander combo' + (n===1?'':'s') + ' (Commander Spellbook)'));
        }
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', mark);
  } else { mark(); }

  // collection filtering, pagination and quick-add re-render sections via fetch
  var t = null;
  new MutationObserver(function(){
    if(t) return;
    t = setTimeout(function(){ t = null; mark(); }, 120);
  }).observe(document.documentElement, { childList:true, subtree:true });
})();
